import React from "react";

const CTA = () => {
	return (
		<div className="rts-cleaning-home-team rts-section-gapBottom bg-team-cleaning-home">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="cta-main-wrapper-cleaning bg_image mb--120">
							<div className="left-content">
								<p className="pre">
									Hai una idea per migliorare <br />
									la tua casa?
								</p>
								<h2 className="title">Noi possiamo realizzarla!</h2>
							</div>
							<div className="button-area">
								<a href="#contact" className="rts-btn btn-primary">
									Parlacene!
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CTA;
